import React from "react";
export default function CloudIndex() {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h2 className="text-2xl font-semibold">Welcome to Fireproof</h2>
      <p className="text-muted-foreground">Here is the cloud</p>
    </div>
  );
}
